import { render, staticRenderFns } from "./TrTextBlockWithInput.vue?vue&type=template&id=2d9c42bc&scoped=true&"
import script from "./TrTextBlockWithInput.vue?vue&type=script&lang=js&"
export * from "./TrTextBlockWithInput.vue?vue&type=script&lang=js&"
import style0 from "./TrTextBlockWithInput.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TrTextBlockWithInput.vue?vue&type=style&index=1&id=2d9c42bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9c42bc",
  null
  
)

export default component.exports